// @flow

import type {History, Location} from 'react-router';
import type {Hero} from '../data/heroes';
import qs from 'query-string';
import heroes from '../data/heroes.js';

type Data = {
  requiredHeroes: Array<Hero>,
  optionalHeroes: Array<Hero>,
  selectedHeroes: Array<Hero>
};

function update(history: History, data: Data): string {
  const query = {
    required_heroes: data.requiredHeroes
      ?.map((hero: Hero) => hero.name)
      .join(',') ?? '',
    optional_heroes: data.optionalHeroes
      ?.map((hero: Hero) => hero.name)
      .join(',') ?? '',
    selected_heroes: data.selectedHeroes
      ?.map((hero: Hero) => hero.name)
      .join(',') ?? '',
  };
  const searchString = qs.stringify(query);
  history.push({search: searchString});
  return searchString;
}

function get(location: Location): Data {
  const params = qs.parse(location.search);
  const requiredHeroes = heroes.filter((hero: Hero) => {
    return params.required_heroes?.split(',').includes(hero.name);
  });
  while (requiredHeroes.length > 4) {
    requiredHeroes.shift();
  }
  const optionalHeroes = heroes.filter((hero: Hero) => {
    return params.optional_heroes?.split(',').includes(hero.name);
  });
  const selectedHeroes = heroes.filter((hero: Hero) => {
    return params.selected_heroes?.split(',').includes(hero.name);
  });
  return {requiredHeroes, optionalHeroes, selectedHeroes};
}


export default {update, get};
